$(document).ready(function(){  
  $('#SingleOptionSelector-0').hide();
  $('#autocomplete-error').hide();

  var places = [
    { value: "Aina Nalu", data: 'Lahaina'},
    { value: "Aloha Campers", data: 'Central Kihei'},
    { value: "Andaz Maui at Wailea", data: 'Wailea'},
    { value: "Aston at Papakea Resort", data: "Ka'anapali"},
    { value: "Aston at the Maui Banyan", data: 'South Kihei'},
    { value: "Aston Kaanapali Shores", data: "Ka'anapali"},
    { value: "Aston Mahana at Kaanapali", data: "Ka'anapali"},
    { value: "Aston Maui Hill", data: 'South Kihei'},
    { value: "Aston Maui Kaanapali Villas", data: "Ka'anapali"},
    { value: "Aston Maui Lu", data: 'North Kihei'},
    { value: "Aston Paki Maui", data: "Ka'anapali"},
    { value: "Central Kihei", data: 'Central Kihei'},
    { value: "Four Seasons", data: 'Wailea'},
    { value: "Garden of West Maui", data: 'Kapalua'},
    { value: "Grand Champions", data: 'Wailea'},
    { value: "Grand Wailea", data: 'Wailea'},
    { value: "Haggai", data: 'Central Kihei'},
    { value: "Hale Hui Kai", data: 'South Kihei'},
    { value: "Hale Kai O Kihei", data: 'Central Kihei'},
    { value: "Hale Kamaole", data: 'South Kihei'},
    { value: "Hale Kanani", data: 'South Kihei'},
    { value: "Hale Mahialani", data: 'South Kihei'},
    { value: "Hale Mahina Beach", data: 'Napili'},
    { value: "Hale Maui", data: "Ka'anapali"},
    { value: "Hale Napili", data: 'Napili'},
    { value: "Hale Ono Loa", data: "Ka'anapali"},
    { value: "Hale Pau Hana", data: 'South Kihei'},
    { value: "Hale Piilani", data: 'North Kihei'},
    { value: "Haleakala Gardens", data: 'Central Kihei'},
    { value: "Haleakala Shores", data: 'South Kihei'},
    { value: "Ho'olei Resort", data: 'Wailea'},
    { value: "Hololani", data: 'Napili'},
    { value: "Honokeana Cove", data: 'Napili'},
    { value: "Honokowai", data: 'Napili'},
    { value: "Honokowai-Sunrise", data: 'Napili'},
    { value: "Honokowai Palms", data: 'Napili'},
    { value: "Honokowai Villa", data: 'Napili'},
    { value: "Honua Kai Resort and Spa", data: "Ka'anapali"},
    { value: "Hotel Wailea", data: 'Wailea'},
    { value: "Hoyochi Nikko", data: 'Napili'},
    { value: "Hyatt Regency", data: "Ka'anapali"},
    { value: "Hyatt Residence Club", data: "Ka'anapali"},
    { value: "Iron Woods", data: 'Kapalua'},
    { value: "Island Sands", data: 'South Kihei'},
    { value: "Island Surf", data: 'Central Kihei'},
    { value: "Kaanapali", data: "Ka'anapali"},
    { value: "Kaanapali Alii", data: "Ka'anapali"},
    { value: "Kaanapali Beach Club", data: "Ka'anapali"},
    { value: "Kaanapali Beach Hotel", data: "Ka'anapali"},
    { value: "Kaanapali Hillside", data: "Ka'anapali"},
    { value: "Kaanapali Royal", data: "Ka'anapali"},
    { value: "Kahana", data: 'Napili'},
    { value: "Kahana Beach", data: 'Napili'},
    { value: "Kahana Falls", data: 'Napili'},
    { value: "Kahana Manor", data: 'Napili'},
    { value: "Kahana Outrigger", data: 'Napili'},
    { value: "Kahana Reef", data: 'Napili'},
    { value: "Kahana Sunset", data: 'Napili'},
    { value: "Kahana Village", data: 'Napili'},
    { value: "Kahana Villas", data: 'Napili'},
    { value: "Kai Makani Beach Villas", data: 'North Kihei'},
    { value: "Kai Malu", data: 'Wailea'},
    { value: "Kaleialoha", data: 'Napili'},
    { value: "Kamaole Beach Royale", data: 'South Kihei'},
    { value: "Kamaole Beach", data: 'South Kihei'},
    { value: "Kamaole Nalu", data: 'South Kihei'},
    { value: "Kamaole Sands", data: 'South Kihei'},
    { value: "Kapalani Estates", data: 'Napili'},
    { value: "Kapalua", data: 'Kapalua'},
    { value: "Kapalua Bay Villas", data: 'Kapalua'},
    { value: "Kapalua Golf Villas", data: 'Kapalua'},
    { value: "Kapalua Ridge Villas", data: 'Kapalua'},
    { value: "Kapalua Villas", data: 'Kapalua'},
    { value: "Ke Alii Ocean Villas", data: 'South Kihei'},
    { value: "Kea Lani (Fairmont)", data: 'Wailea'},
    { value: "Kealia Condo", data: 'North Kihei'},
    { value: "Keonikai Villages", data: 'South Kihei'},
    { value: "Kihei", data: 'Central Kihei'},
    { value: "Kihei Akahi", data: 'South Kihei'},
    { value: "Kihei Alii Kai", data: 'South Kihei'},
    { value: "Kihei Bay Surf", data: 'Central Kihei'},
    { value: "Kihei Bay Vista", data: 'Central Kihei'},
    { value: "Kihei Beach Resort", data: 'North Kihei'},
    { value: "Kihei Boat Ramp", data: 'South Kihei'},
    { value: "Kihei Cove", data: 'Central Kihei'},
    { value: "Kihei Garden Estates", data: 'Central Kihei'},
    { value: "Kihei Holiday", data: 'North Kihei'},
    { value: "Kihei Kai", data: 'North Kihei'},
    { value: "Kihei Kai Nani", data: 'South Kihei'},
    { value: "Kihei Park Shores", data: 'Central Kihei'},
    { value: "Kihei Regency", data: 'South Kihei'},
    { value: "Kihei Resort", data: 'Central Kihei'},
    { value: "Kihei Sands", data: 'North Kihei'},
    { value: "Kihei Surfside", data: 'South Kihei'},
    { value: "Kihei Villages", data: 'North Kihei'},
    { value: "Koa Lagoon", data: 'Central Kihei'},
    { value: "Koa Resorts", data: 'Central Kihei'},
    { value: "Kulakane", data: "Ka'anapali"},
    { value: "Kuleana", data: 'Napili'},
    { value: "Lahaina Ferry", data: 'Lahaina'},
    { value: "Lahaina Harbor", data: 'Lahaina'},
    { value: "Lahaina Inn", data: 'Lahaina'},
    { value: "Lahaina Shores", data: 'Lahaina'},
    { value: "Lahaina's Last Resort", data: 'Lahaina'},
    { value: "Lahaina", data: 'Lahaina'},
    { value: "Lahainaluna", data: 'Lahaina'},
    { value: "Lanikai Condo", data: 'Lahaina'},
    { value: "Launiupoko", data: 'Lahaina'},
    { value: "Lihi Kai Cottages", data: 'South Kihei'},
    { value: "Lokelani", data: 'Napili'},
    { value: "Luana Kai", data: 'Central Kihei'},
    { value: "Maalaea", data: 'North Kihei'},
    { value: "Maalaea Harbor", data: 'North Kihei'},
    { value: "Maalaea Surf", data: 'North Kihei'},
    { value: "Mahina Surf", data: 'Napili'},
    { value: "Mahinahina Beach", data: 'Napili'},
    { value: "Makani Sands", data: 'Napili'},
    { value: "Makena", data: 'Makena'},
    { value: "Makena Beach & Golf Resort", data: 'Makena'},
    { value: "Makena Landing", data: 'Makena'},
    { value: "Makena Surf", data: 'Makena'},
    { value: "Mana Kai Resort", data: 'South Kihei'},
    { value: "Marriott's Maui Ocean Club", data: "Ka'anapali"},
    { value: "Masters", data: "Ka'anapali"},
    { value: "Maui Coast Hotel", data: 'Central Kihei'},
    { value: "Maui Eldorado", data: "Ka'anapali"},
    { value: "Maui Kai", data: "Ka'anapali"},
    { value: "Maui Kamaole", data: 'South Kihei'},
    { value: "Maui Marriott", data: 'Wailea'},
    { value: "Maui Meadows", data: 'Wailea'},
    { value: "Maui Oceanfront", data: 'Wailea'},
    { value: "Maui Parkshore", data: 'South Kihei'},
    { value: "Maui Sands", data: "Ka'anapali"},
    { value: "Maui Schooner", data: 'Central Kihei'},
    { value: "Maui Sunset", data: 'Central Kihei'},
    { value: "Maui Vista", data: 'South Kihei'},
    { value: "Mauian", data: 'Napili'},
    { value: "Menehune Shores", data: 'Central Kihei'},
    { value: "Montage at Kapalua Bay", data: 'Kapalua'},
    { value: "Nani Kai Hale", data: 'North Kihei'},
    { value: "Napili", data: 'Napili'},
    { value: "Napili Bay Resort", data: 'Napili'},
    { value: "Napili Hau Villages", data: 'Napili'},
    { value: "Napili Kai Beach", data: 'Napili'},
    { value: "Napili Point", data: 'Napili'},
    { value: "Napili Shores", data: 'Napili'},
    { value: "Napili Sunset", data: 'Napili'},
    { value: "Napili Surf", data: 'Napili'},
    { value: "Napili Village", data: 'Napili'},
    { value: "Noelani", data: 'Napili'},
    { value: "Nohonani", data: "Ka'anapali"},
    { value: "Nona Lani Cottages", data: 'North Kihei'},
    { value: "North Kihei", data: 'North Kihei'},
    { value: "Olowalu", data: 'Lahaina'},
    { value: "Pacific Shores", data: 'South Kihei'},
    { value: "Palms at Wailea", data: 'Wailea'},
    { value: "Pineapple Hill", data: 'Napili'},
    { value: "Pioneer Inn", data: 'Lahaina'},
    { value: "Plantation Inn", data: 'Lahaina'},
    { value: "Pohailani Maui", data: 'Napili'},
    { value: "Polo Beach Resort", data: 'Wailea'},
    { value: "Polynesian Shores", data: 'Napili'},
    { value: "Puamana Beach", data: 'Lahaina'},
    { value: "Punahoa Beach", data: 'Central Kihei'},
    { value: "Residence Inn by Marriott Maui Wailea", data: 'Wailea'},
    { value: "Ritz Carlton", data: 'Kapalua'},
    { value: "Royal Kahana", data: "Napili"},
    { value: "Royal Lahaina", data: "Ka'anapali"},
    { value: "Royal Mauian", data: 'South Kihei'},
    { value: "Sands of Kahana", data: 'Napili'},
    { value: "Sheraton Maui", data: "Ka'anapali"},
    { value: "South Pointe", data: 'North Kihei'},
    { value: "South Kihei", data: 'South Kihei'},
    { value: "Sugar Beach Resort", data: 'North Kihei'},
    { value: "Sun Seeker", data: 'North Kihei'},
    { value: "The ilikahi", data: 'Lahaina'},
    { value: "The Makai Inn", data: 'Lahaina'},
    { value: "The Pikake", data: "Ka'anapali"},
    { value: "The Shores of Maui", data: 'Central Kihei'},
    { value: "The Whaler on Kaanapali Beach", data: "Ka'anapali"},
    { value: "Valley Isle Resort", data: "Napili"},
    { value: "Village by the Sea", data: 'Central Kihei'},
    { value: "Wailana Kai", data: 'North Kihei'},
    { value: "Wailea", data: 'Wailea'},
    { value: "Wailea Beach Resort - Marriott, Maui", data: 'Wailea'},
    { value: "Wailea Beach Villas", data: 'Wailea'},
    { value: "Wailea Ekahi", data: 'Wailea'},
    { value: "Wailea Ekolu", data: 'Wailea'},
    { value: "Wailea Elua", data: 'Wailea'},
    { value: "Wailea Fairway Villas", data: 'Wailea'},
    { value: "Wailea Golf Course", data: 'Wailea'},
    { value: "Wailea Kai", data: 'Wailea'},
    { value: "Wailea Ocean Front", data: 'Wailea'},
    { value: "Wailea Point", data: 'Wailea'},
    { value: "Waiohuli Beach Hale", data: 'Central Kihei'},
    { value: "Waipuilani", data: 'Central Kihei'},
    { value: "Westin Maui", data: "Ka'anapali"},
    { value: "Westin Nanea Ocean Villas", data: "Ka'anapali"},
    { value: "Westin Villas ", data: "Ka'anapali"},
    { value: "Whaler's Village", data: "Ka'anapali"},
    { value: "Worldmark", data: 'Central Kihei'},
    { value: "Kula", data: 'Upper Country'},
    { value: "Pukalani", data: 'Up Country'},
    { value: "Makawao", data: 'Up Country'},
    { value: "Haiku", data: 'Up Country'},
    { value: "Keokea", data: 'Outer Country'},
    { value: "Ulupalakula", data: 'Outer Country'}
  ];



  $('#autocomplete').autocomplete({
    lookup: places,
    autoSelectFirst: true,
    showNoSuggestionNotice: true,
    noSuggestionNotice: $('#autocomplete-error').show(),
    onSelect: function (suggestion) {
      var place = document.getElementById('SingleOptionSelector-0'),
      	  places = place.options;
       
      for(var i = 0; i < places.length; i++){
        if(places[i].value == suggestion.data){
          places[i].selected = true;
        };
      };
      
      if ("createEvent" in document) {
          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          place.dispatchEvent(evt);
      }else{
          place.fireEvent("onchange");
      };
      
    }
  });
  
});